import * as React from "react";

export default function Title() {
  return (
    <section className="section-title flex">
      <div className="title-header grow">WebRTC experiments</div>
      <div className="title-notes">
        <div>Text messaging and video conferencing</div>
        <div>For learning purpose only</div>
      </div>
    </section>
  );
}
